(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PublicSiteTranslationPropertyDeleteController',PublicSiteTranslationPropertyDeleteController);

    PublicSiteTranslationPropertyDeleteController.$inject = ['$uibModalInstance', 'entity', 'PublicSiteTranslationProperty'];

    function PublicSiteTranslationPropertyDeleteController($uibModalInstance, entity, PublicSiteTranslationProperty) {
        var vm = this;

        vm.publicSiteTranslationProperty = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PublicSiteTranslationProperty.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
